import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useParams } from 'react-router-dom';

import { matchConsolidationDetailRoutePath } from '@futrli/shared-services';
import { useApiView } from '@futrli/views/hooks/useApiView';
import { ReportTemplatesListView } from '@futrli/views/views/reports/ReportTemplatesListView/ReportTemplatesListView';

export const useFutrliTemplates = () => {
  const flags = useFlags();
  const { workspaceId = '', organisationId = '' } = useParams();
  const isConsolidation = !!matchConsolidationDetailRoutePath(window.location.pathname);

  const view = useApiView(
    useMemo(() => new ReportTemplatesListView(workspaceId, organisationId, isConsolidation, flags), [
      flags,
      workspaceId,
      organisationId,
      isConsolidation
    ])
  );

  return {
    futrliTemplates: view.state.futrliTemplates ?? [],
    isLoading: view.state.isLoading,
    errorLoading: view.state.errorLoading
  };
};
